import { useCallback } from 'react';
import {
  tApiErrorObject,
  tProductSearchResponse,
  tSummaryPostObject,
  tDigitalOrderResponse,
  tSettingsResponse,
  tTranslationResponse,
} from '../contexts/zod';
import { useAppInit } from '../contexts/appInitContext';
import { BASE_URL } from '../utils/constants';

interface IhttpErrorResponse {
  code: string;
  message: string;
}

type ThttpMethod = 'POST' | 'GET' | 'DELETE';
type Tcors = '*' | 'no-cors' | 'cors';
type Tbody = FormData | tSummaryPostObject | object | null | '';

export interface IapiResponse {
  status: 'Success' | 'Failure' | undefined;
  errors: IhttpErrorResponse[];
  data?: tTranslationResponse &
  tSettingsResponse &
  tDigitalOrderResponse &
  tProductSearchResponse;
}

const handleError = (traceId: string, errors: tApiErrorObject[]) => {
  const errorsToDisplay = [''];
  errors.forEach((e: tApiErrorObject) => {
    switch (e.code) {
      case 'TBD':
        errorsToDisplay.push(e.message);
        break;
      default:
        break;
    }
  });
  // eslint-disable-next-line no-console
  console.error({ traceId, errorsToDisplay });
};

let traceId = '';

export const useApi = () => {
  const { params } = useAppInit();

  const api = useCallback(
    async (url: string, method: ThttpMethod, cors: Tcors, body?: Tbody, contentType?: string) => {
      let data;
      const headers = new Headers({
        Authorization: `Bearer ${params.drToken}`,
        'Access-Control-Allow-Origin': cors,
        'Trace-Id': traceId,
      });
      if (body) {
        if (contentType === 'application/json' || !contentType) {
          data = JSON.stringify(body);
          headers.append('Content-Type', 'application/json');
        } else {
          data = body;
        }
      }
      const response: Response = await fetch(`${BASE_URL}/${url}`, {
        method,
        headers,
        body: data,
      });

      if (!traceId) {
        traceId = response.headers.get('trace-id') ?? '';
      }
      const formattedResponse = await response.json();

      if (formattedResponse.errors && formattedResponse.errors.length > 0) {
        handleError(traceId, formattedResponse.errors);
        return formattedResponse;
      }

      return formattedResponse as IapiResponse;
    },
    [params.drToken],
  );

  return api;
};
